<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="this.$t('CargoMsg.Cargo_SetAMarginAlert2')"
      width="480px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="140px" label-position="left">
          <el-form-item :label="this.$t('CargoMsg.Cargo_MarginTip1')">
            <auto-number-input v-model="companyThresholdValue" no="1" :min="0" :precision="0" />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_MarginTip2')">
            <auto-number-input v-model="userThresholdValue" no="2" :min="0" :precision="0" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { getReminderFunc, setReminderFunc } from '@/api/booking/mblManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

export default {
  name: 'DistributionWindow',
  components: { AutoNumberInput, CargoAdvanceSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      companyThresholdValue: 0,
      userThresholdValue: 0
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  async beforeMount() {

  },
  async created() {
    this.onshow()
  },
  mounted() {},
  methods: {
    onshow() {
      getReminderFunc({ branchId: this.$store.getters.currentOfficeId }).then((res) => {
        this.companyThresholdValue = Number(res.data.companyThresholdValue)
        this.userThresholdValue = Number(res.data.userThresholdValue)
      })
    },
    saveHandler() {
      const data = {
        companyThresholdValue: this.companyThresholdValue,
        userThresholdValue: this.userThresholdValue,
        branchId: this.$store.getters.currentOfficeId
      }
      this.fullscreenLoading = getLoading4Cxt()
      setReminderFunc(data).then((res) => {
        this.innerVisible = false
        this.$emit('queryList')
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    }
  }
}
</script>
